<template>
  <div :class="$style.container">
    <div :class="$style.header">
      Device Info
    </div>
    <div :class="$style.main">
      <ul
        v-if="isMacOS || isIOS"
        :class="$style.infoList"
      >
        <li :class="$style.infoListItem">
          <span>System ID</span>
          <span>{{ item.id }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>MDM Device ID</span>
          <span>{{ getDeviceId || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>JC Agent Version</span>
          <span>{{ item.agentVersion || unknown }}</span>
        </li>
      </ul>
      <ul
        v-else
        :class="$style.infoList"
      >
        <li :class="$style.infoListItem">
          <span>Instance ID</span>
          <span>{{ item.amazonInstanceID || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>System ID</span>
          <span>{{ item.id }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>JC Agent Version</span>
          <span>{{ item.agentVersion || unknown }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants, { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import SystemInsightsComponentMixin from '../mixins/SystemInsightsComponentMixin';

const storeModel = StoreModelMap[ItemTypeConsts.system];
const { unknown } = Constants;

export default {
  name: 'DeviceInfo',

  mixins: [SystemInsightsComponentMixin],

  data: () => ({
    unknown,
  }),

  computed: {
    ...mapGetters(storeModel, [
      'isIOS',
      'isMacOS',
    ]),

    getDeviceId() {
      const { mdm: { internal: { deviceId = '' } = {} } } = this.item;

      return deviceId;
    },
  },
};
</script>

<style module>
@import '../css/systemInsights.css';
</style>
